/* PUREGLASS — B&A landing: quick add to cart, then open the theme's cart drawer */
(function () {
  if (window.__pgbaInit) return;
  window.__pgbaInit = true;

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function dispatchCartUpdate(cart, sections, variantId, productId) {
    return import('@theme/events')
      .then(function (m) {
        document.dispatchEvent(
          new m.CartAddEvent({}, 'pgba', {
            source: 'pgba',
            itemCount: cart.item_count,
            variantId: String(variantId),
            productId: String(productId),
            sections: sections || {},
          })
        );
        var drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('auto-open')) drawer.open();
      })
      .catch(function () {
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pgba-add]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-pgba-add');
    var productId = btn.getAttribute('data-product-id');
    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    var ids = sectionIds();
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: ids.join(',') }),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.json.description || res.json.message || 'Error');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          btn.removeAttribute('aria-busy');
          btn.classList.add('is-added');
          btn.textContent = '✓ ADDED';
          setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 2200);
          return dispatchCartUpdate(cart, res.json.sections, variantId, productId);
        });
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        btn.textContent = 'SOLD OUT';
        setTimeout(function () { btn.textContent = label; }, 2200);
        console.warn('[pgba] add failed', err);
      });
  });
})();
